import React from "react";

import Card from "react-credit-cards";

import {
  formatCreditCardNumber,
  formatCVC,
  formatExpirationDate,
} from "./utils";
import styles from "./styles.css";

import "react-credit-cards/es/styles-compiled.css";

export default class App extends React.Component {

  render() {
  
    return (
      <div   >
      <h1><br />
        getCredit  <br />
        </h1>
        <div className="App-payment">
           
          <Card
            number="4321********1234"
            name="Johnny John"
            expiry="3099"
            cvc="123"
            focused="number"
           
          />
         
        <h1><br />
    
Credit data receiving system<br /></h1>
<h2>
Easy to use<br />
Free use<br />
Secure data<br /><br />
</h2>
<button className="btn btn-primary btn-block" onClick={()=>{ this.props.history.push('/user-manual');}}>User manual</button>
<button className="btn btn-primary btn-block" onClick={()=>{ this.props.history.push('/get-credit-card-details/-MO0rfu7iS6SO7iFQS2x/client/440$/motto,%20Application%20and%20website%20development/ce82985b-09ac-4fcd-a548-1c2410ffeb28.png');}}>Example of a payment page</button>
<button className="btn btn-primary btn-block" onClick={()=>{ this.props.history.push('/details-receiver');}}>details receiver</button>
<button className="btn btn-primary btn-block" onClick={()=>{ this.props.history.push('/uploader');}}>logo uploader</button>
<button className="btn btn-primary btn-block" onClick={()=>{ this.props.history.push('/Developer-API');}}>Developer API</button>
<button className="btn btn-primary btn-block" onClick={()=>{ this.props.history.push('/terms-of-use');}}>Terms of Use</button>
        
         
        </div>
      </div>
    );
  }
}





// WEBPACK FOOTER //
// ./src/home.js